export const RenderJsxHtml = props => {
    const { children, ...remainingProps } = props;

    if (typeof children === "string") {
        return (
            <div
                {...remainingProps}
                dangerouslySetInnerHTML={{ __html: children }}
            ></div>
        );
    } else {
        return <div {...remainingProps}>{children}</div>;
    }
};

export default RenderJsxHtml;
